import {
  conversionsKeys,
  creditsKeys,
} from "@/features/dashboard/queries/conversions.queries";
import config from "@/lib/config";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

export const useSseRevalidation = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const eventSource = new EventSource(config.apiUrl + `/api/sse`, {
      withCredentials: true,
    });

    eventSource.onopen = () => {
      console.log("Connection established");
    };

    // This will catch any generic messages without a specific event name
    eventSource.onmessage = (event: MessageEvent) => {
      try {
        if (event.data === "revalidate_history") {
          queryClient.invalidateQueries({ queryKey: conversionsKeys.all });
          queryClient.invalidateQueries({ queryKey: creditsKeys });
        }
      } catch (e) {}
    };

    eventSource.onerror = (error) => {
      console.error("SSE Error:", error);
      eventSource.close();
    };

    return () => {
      eventSource.close();
    };
  }, [queryClient]);
};
